import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Typography from "@mui/material/Typography";
import { Button, Stack } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import NavBar from "../../../NavBar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./styles.css";
import { getDriverListRequest } from "../../../redux/driver/action";
import storePersist, { localConstant } from "../../../services/localStorage";
import { useResponsive } from "../../../hooks/useResponsive";
import onboardTeamPlaceHolder from "../../../assets/svg/onboard_team_placeholder.svg";
import MenuBar from "../../menuBar";
import { useRef } from "react";
import CustomLoader from "../../../components/CustomLoader";
import BottomNav from "../../../components/BottomNav/BottomNav";
import CustomDialog from "../../../components/CustomDialog";
import InviteDrivers from "../inviteDrivers";
import { useTranslation } from "react-i18next";

const DriversList = () => {
  const { driverList } = useSelector((state) => state.driverReducer);
  const lgUp = useResponsive("up", "lg");
  const smDown = useResponsive("down", "sm");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const custId = storePersist.get(localConstant.ENTITY_CUSTOMER_ID);
    dispatch(
      getDriverListRequest(custId, (response) => {
        setIsLoading(false);
      }),
    );
  }, []);

  const myRef = useRef({});

  return (
    <div
      style={{
        width: lgUp ? `calc(100% - ${240}px)` : "100%",
        marginLeft: lgUp ? "240px" : 0,
      }}
    >
      <NavBar
        myRef={myRef}
        enableBack={false}
        title={t("pages.driverList.title")}
      />
      <MenuBar myRef={myRef} activeTab={3} />
      {isLoading ? (
        <CustomLoader />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {driverList?.length > 0 && (
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
                margin: 10,
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Segoe UI",
                  fontSize: 16,
                  fontWeight: 700,
                  textAlign: "right",
                  color: "#1D5AB9",
                  top: 98,
                  marginLeft: 2,
                }}
                variant="buttonText"
              >
                {t("pages.driverList.pageHeading")}
              </Typography>

              <Button
                onClick={() => {
                  if (smDown) {
                    navigate("/inviteDrivers");
                    return;
                  }
                  setDialogOpen(true);
                }}
                variant="contained"
                alignSelf={"center"}
                style={{
                  width: 98,
                  height: 32,
                  marginLeft: 88,
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <Typography variant="buttonText" color="common.buttonText">
                  + {t("commonLabels.text04")}
                </Typography>
              </Button>
            </div>
          )}
          <List
            sx={{
              bgcolor: "background.paper",
              width: "100%",
              minHeight: driverList?.length > 0 ? "60vh" : "20vh",
              overflow: "auto",
            }}
          >
            {driverList?.length > 0 &&
              driverList?.map((d, id) => {
                return (
                  <div key={id}>
                    <div
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <ListItem
                        style={{ cursor: "pointer" }}
                        alignItems="center"
                        onClick={() => {
                          navigate("/driverDetails", { state: d });
                        }}
                      >
                        <ListItemAvatar>
                          <div className="driver_number_wrapper">
                            <div className="driver_number">{id + 1}</div>
                          </div>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <div
                              style={{
                                flexDirection: "row",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                color="text.primary"
                                style={{
                                  fontFamily: "Segoe UI",
                                  fontSize: 16,
                                  fontWeight: 600,
                                  textAlign: "left",
                                  letterSpacing: "0.5%",
                                }}
                              >
                                {d.firstName} {d.lastName}
                              </Typography>
                              <Typography
                                style={{
                                  fontFamily: "Segoe UI",
                                  fontSize: 12,
                                  fontWeight: 400,
                                  textAlign: "center",
                                  letterSpacing: "0.5%",
                                  marginLeft: 8,
                                  borderRadius: 5,
                                  backgroundColor: "#80BCFF33",
                                  height: 21,
                                  padding: "2px 3%",
                                  alignSelf: "center",
                                  textTransform: "uppercase",
                                }}
                              >
                                {d.roleCode === "DRIVER"
                                  ? t("commonLabels.text05")
                                  : t("commonLabels.text06")}
                              </Typography>
                            </div>
                          }
                          style={{
                            fontFamily: "Segoe UI",
                            fontSize: 16,
                            fontWeight: 600,
                            textAlign: "left",
                            letterSpacing: "0.5%",
                          }}
                          sx={{ marginLeft: 2 }}
                          secondary={
                            <Stack>
                              <Typography
                                sx={{ display: "inline" }}
                                component="span"
                                variant="caption"
                                color={
                                  d.userStatus === "INACTIVE"
                                    ? "orange"
                                    : "green"
                                }
                              >
                                {d.userStatus === "INACTIVE"
                                  ? t("pages.driverList.text02")
                                  : t("pages.driverList.text03")}
                              </Typography>
                              <Typography
                                sx={{ display: "inline" }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                                {d.userEmail}
                              </Typography>
                            </Stack>
                          }
                        />
                        <ChevronRightIcon
                          style={{
                            color: "grey",
                            width: 40,
                            height: 40,
                          }}
                        />
                      </ListItem>
                    </div>
                    <Divider
                      variant="fullWidth"
                      color="lightGray"
                      style={{ width: "100%" }}
                    />
                  </div>
                );
              })}
            <div style={{ marginBottom: 60 }} />
          </List>
          <img
            src={onboardTeamPlaceHolder}
            hidden={!!driverList?.length}
            style={{
              width: 317,
              height: 240,
              top: 135,
              alignSelf: "center",
            }}
            alt=""
          />
          {!driverList?.length && (
            <Button
              onClick={() => {
                if (smDown) {
                  navigate("/inviteDrivers");
                  return;
                }
                setDialogOpen(true);
              }}
              variant="contained"
              alignSelf={"center"}
              style={{
                alignSelf: "center",
                width: 199,
                height: 32,
                marginLeft: 88,
                alignItems: "center",
                margin: "auto",
                marginTop: "10%",
                display: "flex",
              }}
            >
              <Typography variant="buttonText" color="common.buttonText">
                + {t("pages.driverList.text01")}
              </Typography>
            </Button>
          )}
        </div>
      )}
      <CustomDialog
        isOpen={isDialogOpen}
        title={t("pages.inviteDrivers.pageHeading")}
        Content={InviteDrivers}
        reset={() => setDialogOpen(false)}
      />
      <BottomNav activeTab={3} />
    </div>
  );
};

export default DriversList;
